import { isGlobalVendor, matches } from './registry';

// The Vendors section's filter rail, as pure functions so the page only
// renders what these return. Same facet rule as Plan's projects list
// (STRY0038867): each option's count is what the list would show with that
// option added, given the search and the *other* facets' selections.
//
// `vendors` are the vendor items (source 'vendor') of one section;
// `bypassById` maps vendor id -> that vendor's bypass item, for the vendors
// that have a status page.

export const NO_FAMILY = 'No family';

const familyOf = v => v.family || NO_FAMILY;

// A global vendor is not switched on or off here, so it is neither Enabled nor Disabled.
const STATUS_OPTIONS = [
  { id: 'on', label: 'Enabled', test: v => !isGlobalVendor(v) && Boolean(v.value) },
  { id: 'off', label: 'Disabled', test: v => !isGlobalVendor(v) && !v.value }
];

const STATUSIO_OPTIONS = [
  { id: 'bypass', label: 'Bypass active', test: (v, b) => Boolean(b?.value) },
  { id: 'checked', label: 'Checks running', test: (v, b) => Boolean(b) && !b.value },
  { id: 'none', label: 'No status page', test: (v, b) => !b }
];

export function vendorFacets(vendors, bypassById) {
  const hasStatusIo = Object.keys(bypassById).length > 0;
  // vendors.vendorFamily (what the Prevent sidebar groups by); blank = No family, listed last.
  const families = [...new Set(vendors.map(familyOf))]
    .sort((a, b) => (a === NO_FAMILY) - (b === NO_FAMILY) || a.localeCompare(b))
    .map(f => ({ id: f, label: f, test: v => familyOf(v) === f }));
  return [
    { key: 'status', title: 'Status', options: STATUS_OPTIONS },
    ...(hasStatusIo ? [{ key: 'statusio', title: 'status.io', options: STATUSIO_OPTIONS }] : []),
    ...(families.length > 1 ? [{ key: 'family', title: 'Family', options: families }] : [])
  ];
}

// A vendor passes when it matches the query and, for every facet with a
// selection (except `skipKey`), at least one selected option of that facet.
const passes = (v, bypassById, facets, sel, query, skipKey) =>
  matches(v, query) &&
  facets.every(f => {
    const picked = sel[f.key] || [];
    return (
      f.key === skipKey || !picked.length || f.options.some(o => picked.includes(o.id) && o.test(v, bypassById[v.id]))
    );
  });

export function filterVendors(vendors, bypassById, facets, sel, query) {
  return vendors.filter(v => passes(v, bypassById, facets, sel, query));
}

export function facetCount(vendors, bypassById, facets, sel, query, key, optionId) {
  const option = facets.find(f => f.key === key)?.options.find(o => o.id === optionId);
  if (!option) return 0;
  return vendors.filter(v => passes(v, bypassById, facets, sel, query, key) && option.test(v, bypassById[v.id])).length;
}
